import { XStack } from "tamagui";
import { Block } from "./Block";
import { Body } from "./Body";
import type { IconProp } from "./icons";
import { Label } from "./Label";

type IconBoxProps = {
  label?: string;
  subText?: string;
  icon?: IconProp;
  linkOrInfo?: React.ReactNode;
  children?: React.ReactNode;
  grouped?: boolean;
  onPress?: () => void;
};

export const IconBox = ({
  label,
  subText,
  icon,
  linkOrInfo,
  grouped,
  children,
  onPress,
}: IconBoxProps) => {
  const Icon = icon;
  return (
    <Block
      onPress={onPress}
      grouped={grouped}
      icon={Icon ? <Icon /> : undefined}
    >
      <XStack justifyContent="space-between" width="100%">
        <Label>{label}</Label>
        {linkOrInfo}
      </XStack>
      {!!subText && <Body>{subText}</Body>}
      {children}
    </Block>
  );
};
